import HeatPumpRecommender from '@components/components/HeatPumpRecommender/HeatPumpRecommender';
import addresses from '@components/components/CmsComponents/components/CmsHeatPumpRecommender/HeatPumpAddresses.js';
import React from 'react';

const CmsHeatPumpRecommender = ({ visible, signUpLink }) => (
  <HeatPumpRecommender
    addresses={addresses}
    isVisible={!!visible}
    signUpLink={signUpLink}
  />
);

export default CmsHeatPumpRecommender;
